import React, {useState} from 'react'
import Layout from '../Layout/Layout';

import TopMenu from "~/Admin/Layout/TopMenu/TopMenu";
import {NavLink, Route} from "react-router-dom";

import {connect} from "react-redux";
import AdminDietaries from './AdminDietaries/AdminDietaries'

const AdminSettings = ({match, ...props}) => {

    return (
        <Layout>

            <h1>Settings</h1>

            <TopMenu>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}`}>
                    Dietaries
                </NavLink>
            </TopMenu>

            <div className="content mt-5">
                <Route exact path={`${match.path}`} component={AdminDietaries} />
            </div>

        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminSettings);
